import { FC, PropsWithChildren } from 'react';
import CheckboxInput, { CheckboxInputProps } from '@/components/functional/CheckboxInput/CheckboxInput.tsx';
import {
  CheckboxGroupProvider,
  CheckboxGroupProviderProps,
  useCheckboxGroupContext,
} from '@/components/functional/CheckboxInput/CheckboxGroupContext.tsx';

function Group<T extends any[]>({ children, ...props }: PropsWithChildren<CheckboxGroupProviderProps<T>>) {
  return <CheckboxGroupProvider {...props}>{children}</CheckboxGroupProvider>;
}

const Input: FC<Omit<CheckboxInputProps, 'type'>> = ({ label, wrapperClassName, value, color, ...rest }) => {
  const { value: globalValue, setValue, error, color: globalColor } = useCheckboxGroupContext();

  return (
    <CheckboxInput
      wrapperClassName={wrapperClassName}
      error={error}
      label={label}
      value={value}
      checked={globalValue.includes(value)}
      onChange={(e) => setValue(e.target.value)}
      color={color ?? globalColor}
      {...rest}
      type="checkbox"
    />
  );
};

export default {
  Group,
  Input,
};
